import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { changeContactModalVisible } from '../../../DataStore/actions/searchFormActions';
import './css/BurgerMenu.css';
import {
  ABOUT_US,
  CONTACTS,
  BLOG,
  CONTACTS_US,
} from '../../../Utils/Constants/HeaderConstats';
import {
  PHONE_NUMBER,
  PHONE_NUM_CALL,
} from '../../../Utils/Constants/GlobalConstants';
import { ReactComponent as PhoneIco } from '../../../images/phone-r.svg';
import { ReactComponent as WriteIco } from '../../../images/write-r.svg';

const mapStateToProps = (state) => ({ ...state });

class BurgerMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleContanctUsModal = () => {
    const { changeContactModalVisible: changeContactModalVisibleAction } =
      this.props;

    changeContactModalVisibleAction(true);
    document.body.style.overflow = 'hidden';
  };

  render() {
    return (
      <div className="burger_w">
        <div className="burger_menu_w">
          <Link to="/about/" className="h_menu_link br_text_16">
            {ABOUT_US}
          </Link>
          <Link to="/contacts/" className="h_menu_link br_text_16">
            {CONTACTS}
          </Link>
          <Link to="/blog/" target="_blank" className="h_menu_link br_text_16">
            {BLOG}
          </Link>
        </div>

        <a href={`tel:${PHONE_NUM_CALL}`} className="burger_phone_w">
          <PhoneIco className="burger_menu_ico" />
          <div className="br_text_16">{PHONE_NUMBER}</div>
        </a>
        <button
          type="button"
          className="br_text_16 burger_contact"
          onClick={this.handleContanctUsModal}
        >
          <WriteIco className="burger_menu_ico" />
          {CONTACTS_US}
        </button>
      </div>
    );
  }
}

BurgerMenu.propTypes = {
  changeContactModalVisible: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { changeContactModalVisible })(
  BurgerMenu,
);
